export const APP = {
    ID: "Gutachter_Admin",
}